// Mock blog post drafts for the Blog Studio.
// Stored separately from social `assets` because blogs have richer fields (cover, SEO, body_html).

export const mockBlogs = [
  {
    id: "blog_chatbots_vs_workflows",
    title: "Chatbots vs Workflows: The Real Operator Test",
    slug: "chatbots-vs-workflows",
    status: "draft",
    cover_image: null,
    seo_title: "Chatbots vs Workflows: The Real Operator Test",
    seo_meta: "A four-part decision test to tell whether your AI is a chatbot in a trench coat or a real autonomous workflow.",
    excerpt: "Most AI products shipped in 2025 were chatbots in a trench coat. Here's the four-part test that separates them from real workflows.",
    tags: ["AI", "Operators", "Agents"],
    body_html: `<h1>Chatbots vs workflows</h1>
<p>A chatbot is a UI. A workflow is an agent. The difference isn't aesthetic — it's whether the system <em>makes decisions</em> between inputs and outputs.</p>
<h2>The four-part test</h2>
<ol>
  <li><strong>Who owns the goal?</strong> If a human does, you have a chatbot.</li>
  <li><strong>Who picks the skill?</strong> If a router does, you're moving toward a workflow.</li>
  <li><strong>Who critiques the draft?</strong> Self-critique is a sign of an agent, not a chatbot.</li>
  <li><strong>Who decides &lsquo;good enough&rsquo;?</strong> This should remain human. Always.</li>
</ol>
<h2>Why this matters in 2026</h2>
<p>The operators winning quietly aren't the ones with the smartest model. They're the ones who automated three of the four and kept the last one firmly human.</p>
<blockquote>The unlock isn't a smarter model. It's better routing.</blockquote>
<p>Once you see the test, you can't un-see it. Every &ldquo;AI product&rdquo; you evaluate falls cleanly onto one side or the other.</p>`,
    word_count: 187,
    author: "Adam",
    updated_at: "2026-01-22T16:42:00Z",
    schedule_at: null,
    published_at: null,
  },
  {
    id: "blog_skills_primitive",
    title: "Skills are the missing primitive of agent design",
    slug: "skills-missing-primitive",
    status: "needs_review",
    cover_image: null,
    seo_title: "Skills: The Missing Primitive of Agent Design",
    seo_meta: "Why phase-aware skill libraries outperform prompt tuning for operators building agentic systems.",
    excerpt: "We've spent three years polishing prompts. The breakthrough wasn't there — it was in treating capability as a contract.",
    tags: ["Skills", "Agents", "Codex"],
    body_html: `<h1>Skills are the missing primitive</h1>
<p>For three years, the conversation has been about prompts. Better prompts. Cleaner prompts. Prompts as a craft.</p>
<p>The operators winning this year aren't writing better prompts. They're maintaining a private <strong>skill library</strong> and letting their agents route by phase.</p>
<h2>What is a skill?</h2>
<p>A skill is a contract:</p>
<ul>
  <li><strong>When</strong> to use it — the phase it belongs to</li>
  <li><strong>What inputs</strong> it expects</li>
  <li><strong>What outputs</strong> it produces</li>
  <li><strong>What it refuses</strong> to do</li>
</ul>
<h2>The five phases</h2>
<ol>
  <li><strong>Research</strong> — gather + filter sources</li>
  <li><strong>Planning</strong> — choose a strategy</li>
  <li><strong>Generation</strong> — produce the artifact</li>
  <li><strong>Critique</strong> — pressure-test it</li>
  <li><strong>Formatting</strong> — ship it where it needs to go</li>
</ol>
<p>That's the whole game.</p>`,
    word_count: 142,
    author: "Adam",
    updated_at: "2026-01-21T12:15:00Z",
    schedule_at: null,
    published_at: null,
  },
];
